import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";
import API from "../../api/axiosConfig";
import TestPreLoader from "../TestPreLoader/TestPreLoader";
import TableComponent from "../../components/TableComponent";

function HcVendorReport() {
    const columns = [
        { name: "إسم المستفيد", key: "humancase" },
        { name: "إسم المورد", key: "vendor" },
        { name: "المبلغ ", key: "amount" },
        { name: "الحالة ", key: "status" },
        { name: "الكود ", key: "code" },
        { name: "تاريخ الصلاحية ", key: "expiration_date" },
    ];


 


   

 
    return (
        <>
            <div className="printcasedata-container">

                <TableComponent
                    apiUrl="/humancasevendor/act"
                    columns={columns}
                    title="تقرير المدفوعات"
                    titleIcon={<FontAwesomeIcon icon={faPrint} />}
                    searchTextProp={true}
                    searchDate={false}
                />
            </div>
        </>
    );
}

export default HcVendorReport;
